export enum ChannelType {
  PHONE = 'PHONE',
  UNITARY_PHONE = 'UNITARY_PHONE',
  MAIL = 'MAIL',
  CHAT = 'CHAT',
  CHAT_IADVIZE = 'CHAT_IADVIZE',
  FAX = 'FAX',
  EXTERNAL_SERVICE = 'EXTERNAL_SERVICE',
  ALL = 'ALL',
  NOTSET = 'NOTSET',
  WEBRTC = 'WEBRTC',
  VIDEO = 'VIDEO',
  VISIO = 'VISIO',
  BASKET = 'BASKET',
  SOCIAL_NETWORK = 'SOCIAL_NETWORK',
  SURVEY = 'SURVEY',
  CHATBOT = 'CHATBOT',
  SMS = 'SMS',
}

export enum ChannelDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  BOTH = 'BOTH',
  NOTSET = 'NOTSET',
}

export enum ChannelSubType {
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  FACEBOOK_MESSENGER = 'messenger',
}

export const NotSet: Channel = {
  type: ChannelType.NOTSET,
  direction: ChannelDirection.NOTSET,
};

export const AllBoth: Channel = {
  type: ChannelType.ALL,
  direction: ChannelDirection.BOTH,
};

export const PhoneIn: Channel = {
  type: ChannelType.PHONE,
  direction: ChannelDirection.INCOMING,
};

export const PhoneOut: Channel = {
  type: ChannelType.PHONE,
  direction: ChannelDirection.OUTGOING,
};

export const PhoneUnit: Channel = {
  type: ChannelType.UNITARY_PHONE,
  direction: ChannelDirection.OUTGOING,
};

export const MailIn: Channel = {
  type: ChannelType.MAIL,
  direction: ChannelDirection.INCOMING,
};

export const MailOut: Channel = {
  type: ChannelType.MAIL,
  direction: ChannelDirection.OUTGOING,
};

// should be same as MailOut
export const MailUnit: Channel = {
  type: ChannelType.MAIL,
  direction: ChannelDirection.OUTGOING,
};

export const Chat: Channel = {
  type: ChannelType.CHAT,
  direction: ChannelDirection.INCOMING,
};

export const Chatbot: Channel = {
  type: ChannelType.CHATBOT,
  direction: ChannelDirection.INCOMING,
};

export const ChatIAdvise: Channel = {
  type: ChannelType.CHAT_IADVIZE,
  direction: ChannelDirection.INCOMING,
};

export const VisioOut: Channel = {
  type: ChannelType.VISIO,
  direction: ChannelDirection.OUTGOING,
};

export const SocialNetwork: Channel = {
  type: ChannelType.SOCIAL_NETWORK,
  direction: ChannelDirection.INCOMING,
};

export const Basket: Channel = {
  type: ChannelType.BASKET,
  direction: ChannelDirection.INCOMING,
};

export const Channels: Channel[] = [PhoneIn, PhoneOut, MailIn, MailOut, Chat, Chatbot, ChatIAdvise, SocialNetwork, VisioOut];

/**
 * Channel model
 */
export interface Channel {
  readonly type: ChannelType;
  readonly direction: ChannelDirection;
}

/**
 * Utility method to compute channel state id
 */
export function toChannelId(channel: Channel) {
  return `${channel.type}_${channel.direction}`;
}
